<div class="dialog">
  <div class="dialog-box">
    <h2 mat-dialog-title>  {{local_data.title}}  </h2>
  </div>
  <div class="dialog-box-s">
    <div class="dialog-flex mb-5">
      @if (formGroup1) {
        <form [formGroup]="formGroup1">
          <div class="dialog-box dialog-box-m">
            <mat-form-field>
              <mat-label>{{variables.region}}</mat-label>
              <input type="text" matInput formControlName="regionCtrl">
            </mat-form-field>
            <mat-form-field>
              <mat-label>{{variables.gcm}}</mat-label>
              <input type="number" matInput formControlName="gcmCtrl">
            </mat-form-field>
            <mat-form-field [ngClass]="{'mat-form-field-custom': true, 'ng-invalid': invalidInput, 'mat-form-field-invalid': invalidInput}" class="form-field" appearance="fill">
              <mat-label>{{variables.costHour}}</mat-label>
              <input type="number" step="0.01" matInput formControlName="costCtrl">
              @if (invalidInput) {
                <mat-hint class="error-hint">{{errorMessage}}</mat-hint>
              }
            </mat-form-field>
          </div>
        </form>
      }
    </div>
  </div>
  <div class="dialog-box-s">
    <mat-dialog-actions class="button-group">
      <app-button typeBtn="secondary" message="{{variables.goBack}}" mat-dialog-close ></app-button>
      <app-button typeBtn="primary" (click)="doAction()"  message="{{variables.next}}"></app-button>
    </mat-dialog-actions>
  </div>

</div>
